/**
 * @file Initialize the IndexedDB database
 */
import { IDB__DB_NAME, IDB__VERSION, IDB__STORES_MAP } from './constants';
/**
 * Initialize the IndexedDB database
 * (and run migrations if needed)
 *
 * @returns The database itself
 */
const initDB = () => {
    const request = self.indexedDB.open(IDB__DB_NAME, IDB__VERSION);
    /**
     * The database didn't already exist, or it was on old version,
     * so we initialize the db and the stores
     */
    const onUpgradeNeeded = () => {
        IDB__STORES_MAP.forEach((options, name) => {
            const storeExists = request.result.objectStoreNames.contains(name);
            if (storeExists === false) {
                const objectStore = request.result.createObjectStore(name, options);
                const { keyPath } = options;
                if (typeof keyPath === 'string') {
                    objectStore.createIndex(keyPath, keyPath, { unique: true });
                }
            }
        });
    };
    request.addEventListener('upgradeneeded', onUpgradeNeeded, false);
    /**
     * request.result will be null until
     * 'success|blocked|error|upgradeneeded' is fired
     */
    return new Promise((resolve, reject) => {
        request.addEventListener('blocked', () => {
            reject('The user has blocked IndexedDB from running');
        });
        request.addEventListener('error', () => {
            reject('There was an error opening the database');
        });
        request.addEventListener('success', () => {
            resolve(request.result);
        });
    });
};
export default initDB;
//# sourceMappingURL=initDB.js.map